import { useDispatch } from '@witmetrics/data-store';
import { API } from '@/api';
import { showSuccessToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteFileDialogProps = {
  fileId: number;
  onDelete?: (fileId: number) => void;
  onClose: () => void;
};

export default function DeleteFileDialog({
  fileId,
  onDelete,
  onClose,
}: DeleteFileDialogProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const [isDeleting, toggleDeleting] = useToggle();

  const handleDelete = async () => {
    try {
      toggleDeleting(true);
      await API.Files.removeFile(fileId);
      dispatch.deleteFile({ fileId });
      if (onDelete) onDelete(fileId);
      showSuccessToaster('File deleted');
      toggleDeleting(false);
      onClose();
    } catch (err) {
      toggleDeleting(false);
      onApiError(err, 'Error deleting file', () => {
        handleDelete();
      });
    }
  };

  return (
    <DefaultDialog
      disabled={isDeleting}
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Delete"
      pendingLabel="Deleting"
      title="Delete file"
      message="Are you sure you want to remove this file? All versions of this file will also be removed. This action cannot be undone."
      onCancel={onClose}
      onConfirm={handleDelete}
      onClose={onClose}
    />
  );
}
